export default __webpack_public_path__ + "img/cog-icon.d04aba0a.svg";